import { CustomAsyncPipe } from '@/shared/utils/angular-sdk';
import { Pipe, type PipeTransform, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import type { Project } from '../interfaces/Project.interface';
import { ProjectsProvider } from '../providers/projects/projects.provider';

@Pipe({
    name: 'project',
    pure: false
})
export class ProjectPipe extends CustomAsyncPipe<string, Project | null> implements PipeTransform {
    private _projectsProvider = inject(ProjectsProvider);

    transformInputIntoObservableOfOutput(projectId: string): Observable<Project | null> {
        return this._projectsProvider.getProjectById$(projectId);
    }
}
